/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Wrap_NoneInputs */



/**
* | output |
* | --- |
* | "No wrap" |
*
* @param {Transcript_Export_Wrap_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_wrap_none = /** @type {((inputs?: Transcript_Export_Wrap_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Wrap_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "de") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "it") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "es") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No wrap")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No wrap")
	return /** @type {LocalizedString} */ ("No wrap")
});